// extracted by mini-css-extract-plugin
export default {"config":"AppConfig_config__H+OOG","config__link":"AppConfig_config__link__UfwVW"};